import { ChartBar } from "@phosphor-icons/react";
import { StatGrid } from "./StatGrid";
import { EmptyState } from "../shared/EmptyState";

export const OffenseCard = ({ label, block, testId }) => {
  const derived = block?.derived || {};
  const available = block?.status === "available";
  return (
    <div data-testid={testId} className="flex flex-col gap-3 rounded-lg border border-white/10 bg-eb-surface p-4">
      <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">{label}</span>
      {available ? (
        <>
          <StatGrid
            testIdPrefix={testId}
            stats={[
              { label: "Runs/Game", value: derived.runs_per_game },
              { label: "AVG", value: derived.avg },
              { label: "OBP", value: derived.obp },
              { label: "SLG", value: derived.slg },
              { label: "OPS", value: derived.ops },
              { label: "ISO", value: derived.iso },
              { label: "HR%", value: derived.hr_rate_pct != null ? `${derived.hr_rate_pct}%` : null },
              { label: "K%", value: derived.k_pct != null ? `${derived.k_pct}%` : null },
              { label: "BB%", value: derived.bb_pct != null ? `${derived.bb_pct}%` : null },
              { label: "wOBA", value: derived.woba },
              { label: "wRC+", value: derived.wrc_plus },
              { label: "vs LHP", value: null },
              { label: "vs RHP", value: null },
            ]}
          />
          <p className="font-mono text-[10px] text-zinc-600">Overall season-to-date only &mdash; platoon splits not yet ingested.</p>
        </>
      ) : (
        <EmptyState icon={ChartBar} title="Statistics Unavailable" description={block?.reason} testId={`${testId}-empty`} />
      )}
    </div>
  );
};
